exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SaveDetalization_fileFormat_3Hjb {\n  margin: 20px auto 30px auto;\n  padding: 16px;\n\n  max-width: 60px;\n\n  border: 2px solid #f9c872;\n  border-radius: 5px;\n}\n\n.SaveDetalization_checkboxesWrapper_35_V {\n  margin-bottom: 40px;\n}\n\n.SaveDetalization_checkboxes_Mm74 {\n  margin: auto;\n\n  width: 280px;\n\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"fileFormat": "SaveDetalization_fileFormat_3Hjb",
	"checkboxesWrapper": "SaveDetalization_checkboxesWrapper_35_V",
	"checkboxes": "SaveDetalization_checkboxes_Mm74"
};